import React  from "react";
import "../Footer/Footer.css";
import Container from "../Container/Index";
import  Call from "../../images/Vectors/Call";
import Email from "../../images/Vectors/Mail";
import Address from "../../images/Vectors/Location";
import { NavLink } from "react-router-dom";

const Index = () => {
  const year = new Date().getFullYear();
  return (
    <>
      <footer className="col-12 float-start mb-5 mb-lg-0">
        <Container
          _parentClass="p-100 pb-0"
          containerClass={"float-end bg-primary topBorderband"}
        >
          <div
            className="col-lg-10 col-sm-11 col-12 m-auto p-100 pb-2"
            data-aos="fade-in"
            data-aos-offset="200"
            data-aos-duration="500"
            data-aos-once="true"
            data-aos-easing="ease-in-sine"
          >
            <div className="col-12 mb-sm-5 float-start">
              <div className="footerbox col-12 float-start">
                <div className="col-12 float-start d-flex justify-content-between flex-wrap text-white"  data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="500"
            data-aos-once="true"
            data-aos-easing="ease-in-sine">
                 <div className="footercolumn">
                    <h3 className="fw-bold text-uppercase mb-sm-3  mb-1">Quick Links</h3>
                    <ul>
                      
                    <li><NavLink to='/'>Home</NavLink></li>
                      <li><NavLink to='/about-arsus-global'>About Us</NavLink></li>
                      <li><NavLink to='/our-facility'>Our Facility </NavLink></li>
                      <li><NavLink to='/our-clients'>Our Clients</NavLink></li>                      
                      <li><NavLink to='/sustainability'>Sustainability</NavLink></li>
                      <li><NavLink to='/gallery'>Gallery</NavLink></li>
                      <li><NavLink to='/career'>Career</NavLink></li>
                      <li><NavLink to='/contact-us'>Contact Us</NavLink></li>
                     
                    </ul>
                  </div>
                  
                  <div className="footercolumn">
                    <h3 className="fw-bold text-uppercase mb-sm-3  mb-1">  <NavLink to='/our-services'>Our Services </NavLink></h3>
                    
                    <ul>
                    <li><NavLink to='/our-services/blending'>Blending</NavLink></li>
                    <li><NavLink to='/our-services/bottling'>Bottling</NavLink></li>
                    <li><NavLink to='/our-services/packaging'>Packaging</NavLink></li>
                    <li><NavLink to='/our-services/logistics'>Logistics</NavLink></li>
                    </ul>
                  </div>
                  <div className="footercolumn">
                    <h3 className="fw-bold text-uppercase mb-sm-3  mb-1">Know more</h3>
                    <ul>
                    <li><NavLink to='/terms-conditions'>Terms & Conditions</NavLink></li>
                    <li><NavLink to='/privacy-policy'>Privacy Policy</NavLink></li>
                    </ul>
                  </div>
                  <div className="footercolumn">
                    <h3 className="fw-bold text-uppercase mb-sm-3  mb-1">Contact Us</h3>
                    <div className="footerbox follow_us">
                      <ul className="d-grid">
                      <li className="tel">
                          <span>
                            <Call />
                          </span>
                          <p><a href="tel:09134320504">09134320504</a></p>
                        </li>
                        <li className="fb">
                          <span>
                            <Email />
                          </span>
                          <p><a href="mailto:arsusglobal@gmail.com">arsusglobal@gmail.com</a></p>
                        </li>
                        <li className="fb">
                          <span>
                            <Address />
                          </span>
                          <p><strong className='text-uppercase'>Arsus Global Resources Ltd.
          </strong><br/>Along Abeokuta-Sagamu Expressway<br/>Siun, Obafemi-Owode LGA<br/>Ogun, Nigeria</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 float-start d-flex justify-content-between pt-3 pb-3 mt-sm-5 copyrightcont text-white">
              <p>
                &copy; {year} Arsus Global | All Rights Reserved 
             
              </p>
              <p>
                <a
                  href="https://triverseadvertising.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  site: triverse
                </a>
              </p>
            </div>
          </div>
        </Container>
      </footer>
      
    </>
  );
};

export default Index;
